// extracted by mini-css-extract-plugin
module.exports = {"Body--title":"Body--title__210Od","Body--header":"Body--header__2vhDd","Body--resend-text":"Body--resend-text__1USvL","inline-container":"inline-container__24Ah7"};